import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'sweetalert2/dist/sweetalert2.min.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


        <BrowserRouter>
          <App />
        
        </BrowserRouter>
  

);


